import { Menu } from "lucide-react";
import { navLinks } from "../../data/landingData";

export function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-borderSoft/70 bg-white/95 backdrop-blur">
      <div className="section-shell flex h-16 items-center justify-between">
        <a href="#inicio" className="inline-flex items-center">
          <img src="/logo_nav-40.svg" alt="+10" className="h-8 w-auto" />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => {
            const external = link.href.startsWith("http");
            return (
              <a
                key={link.href}
                href={link.href}
                {...(external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
                className="text-sm font-medium text-ink transition hover:text-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2"
              >
                {link.label}
              </a>
            );
          })}
        </nav>
        <button
          type="button"
          aria-label="Abrir menu"
          className="rounded-full border border-borderSoft p-2 text-brand-700 md:hidden"
        >
          <Menu size={18} />
        </button>
      </div>
    </header>
  );
}
